<template>
<div class="theme-tour w-full">
    <div>
        <div class="modal" :class="'aa' + this.id" data-feature="modal" :data-name="`appointment_signup_` + this.id + this.type">
            <div class="modal__content" data-feature="modal-active-area">
                <div class="">
                    <h3 class="panel__title">{{appointmentTitle}}</h3>
                    <div class="panel__paragraph">{{localAppointmentParagraphComputed}}</div>
                    <div class="panel__paragraph">
                        <button class="theme-btn theme-btn--block theme-btn--primary signup-button" @click="signUp">{{appointmentButton}}</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" :class="'bb' + this.id" data-feature="modal" :data-name="`appointment_reservelist_signup_` + this.id + this.type">
            <div class="modal__content" data-feature="modal-active-area">
                <div class="">
                    <h3 class="panel__title">{{appointmentReservelistTitle}}</h3>
                    <div class="panel__paragraph">{{appointmentReservelistParagraph}}</div>
                    <div class="panel__paragraph">
                        <button class="theme-btn theme-btn--block theme-btn--primary signup-button" @click="signUp">{{appointmentReservelistButton}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <span v-if="isSigned">
            <template v-if="isReserve">
                {{locales.property && locales.property.signed_for_reservelist}}
            </template>

            <template v-else>
                <button class="theme-btn theme-btn--destructive signout-button" @click="signOut">
                  {{locales.appointments && locales.appointments.sign_out}}
                </button>
            </template>
        </span>

        <button v-else class="theme-btn theme-btn--block theme-btn--primary signup-button" :class="{reservelist__button: isReserve}" data-feature="open-modal" :data-target="target">
            <template v-if="isReserve">
                {{appointmentReservelistListingButton}}
            </template>

            <template v-else>
                {{locales.property && locales.property.sign_up_for_this_viewing}}
            </template>
        </button>
    </div>
</div>
</template>

<script>
import { signOutViewing, showBannedNotice } from '../helpers/viewingSignOut'
import { signUpOutcome, leaveFor } from '../helpers/viewingSignUp'
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import $ from "jquery";
import sweetalert from "sweetalert";
export default {
    computed: {
        ...mapGetters(["locales"]),
        target () {
            return this.isReserve ? 'appointment_reservelist_signup_' + this.id + this.type : 'appointment_signup_' + this.id + this.type;
        },
        localAppointmentParagraphComputed () {
            return this.localAppointmentParagraph.replace(":date", this.date).replace(":time", this.time)
        }
    },
    data() {
        return {
            isSigned: this.signed,
            isReserve: this.reserve,
            localAppointmentParagraph: this.appointmentParagraph
        }
    },
    props: {
        id: 0,
        signed: true,
        reserve: false,
        appointmentTitle: {
            default: '',
            type: String
        },
        appointmentParagraph: {
            default: '',
            type: String
        },
        appointmentButton: {
            default: '',
            type: String
        },
        appointmentReservelistTitle: {
            default: '',
            type: String
        },
        appointmentReservelistParagraph: {
            default: '',
            type: String
        },
        appointmentReservelistButton: {
            default: '',
            type: String
        },
        appointmentReservelistListingButton: {
            default: '',
            type: String
        },
        date: {
            default: '',
            type: String
        },
        time: {
            default: '',
            type: String
        },
        type: {
            default: '',
            type: String
        },
    },
    methods: {
        signUp () {
            $('.signup-button, .signout-button').attr('disabled',true);
            window.axios.post('/api/appointments/' + this.id + '/sign-up').then(
                (response) => this.afterSignUp(signUpOutcome({ data: response.data }, this.locales, window.location.href)),
                (error) => this.afterSignUp(signUpOutcome({ error }, this.locales, window.location.href))
            );
        },
        // Only a sign-up that went through, or a session that is gone, leaves the page; a refusal shows why
        // and stays, so the button cannot come back by itself in a reload loop (see helpers/viewingSignUp).
        afterSignUp (outcome) {
            $('.modal').hide();
            let page = document.getElementById('page');
            if (page) {
                page.classList.remove("z-index");
            }
            if (outcome.kind === 'signed') {
                this.isSigned = true;
            }
            const signed = outcome.kind === 'signed';
            sweetalert(signed ? this.locales.common.success : this.locales.common.error, outcome.text, signed ? 'success' : 'error').then(() => {
                $('.signup-button, .signout-button').removeAttr('disabled');
                if (outcome.url) {
                    leaveFor(outcome.url, window.location);
                }
            });
        },
        signOut: function () {
            window.app.sweetalert(this.locales.appointments && this.locales.appointments.are_you_sure_you_want_to_cancel, {
                buttons: ['Cancel', 'Ok'],
            }).then(value => {
                if (value) {
                    const deps = { http: window.axios, sweetalert: window.app.sweetalert };
                    signOutViewing(this.id, deps).then((result) => {
                        if (result === null) {
                            return;
                        }
                        return showBannedNotice(result, deps, (this.locales['my-viewings'] && this.locales['my-viewings'].late_cancelled_banned_title) || '').then(() => {
                            window.location.reload();
                        });
                    });
                }
            });
        },
    }
}
</script>
